<ng-container>
  <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
  <div class="{{classContainer}}">
    <div *ngFor="let item of listRadioButtons" class="field-checkbox">
      <p-radiobutton [inputId]="item.value.toString()" [value]="item.value" [(ngModel)]="value" [disabled]="disabled"
        (onClick)="changeRadioButton($event)" />
      <label [for]="item.value" class="ml-2">{{ item.label }}</label>
    </div>
  </div>
</ng-container>